const interactionName = 'delete-card';
const what = `[data-interaction="${interactionName}"]`;
const oncls = 'interaction-active';
const triggerEvent = `interaction--${interactionName}-event`;

function init() {
  $('body').on(`${triggerEvent}`, what, (e) => {
    e.preventDefault();
    e.stopPropagation();
    hide(e.target);
  });
}

function hide(item) {
  const $item = $(item);
  const totalHeight = $item.outerHeight(true);

  $item.css({
    height: `${totalHeight}px`,
  });

  requestAnimationFrame(() => {
    $item.addClass(oncls);
    setTimeout(() => {
      $item.remove();
    }, 300);
  });
}

function destroy() {
  $('body').off(`${triggerEvent}`, what);
}

module.exports = {
  init,
  hide,
  destroy,
};
